import React, { useState, useEffect } from 'react';
import './stylesLoader.css'

export const TruckLoader = ({ isLoading = true, message = "Cargando datos..." }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (isLoading) {
      const interval = setInterval(() => {
        setProgress(prev => {
          if (prev >= 100) return 0;
          return prev + Math.random() * 3;
        });
      }, 150);

      return () => clearInterval(interval);
    }
  }, [isLoading]);

  if (!isLoading) return null;

  return (
    <div className="div-loader">
    <div id="truckLoader" class="truck-loader">
           
            <div class="road-container">
                <div class="road"></div>
                <div class="road-lines">
                    <div class="road-line"></div>
                    <div class="road-line"></div>
                    <div class="road-line"></div>
                    <div class="road-line"></div>
                    <div class="road-line"></div>
                    <div class="road-line"></div>
                    <div class="road-line"></div>
                    <div class="road-line"></div>
                </div>
                
             
                <div class="truck-table">
                    <div class="truck-cabin">
                        <div class="truck-window"></div>
                        <div class="truck-detail"></div>
                    </div>
                    <div class="truck-trailer">
                        <div class="trailer-interior">
                            <div class="trailer-box"></div>
                            <div class="trailer-box"></div>
                            <div class="trailer-box"></div>
                            <div class="trailer-box"></div>
                            <div class="trailer-box"></div>
                            <div class="trailer-box"></div>
                        </div>
                    </div>
                    <div class="truck-wheels">
                        <div class="wheel"></div>
                        <div class="wheel"></div>
                        <div class="wheel"></div>
                        <div class="wheel"></div>
                    </div>
                </div>
                
               
                <div class="truck-smoke">
                    <div class="smoke-puff"></div>
                    <div class="smoke-puff"></div>
                    <div class="smoke-puff"></div>
                </div>
            </div>

          
            <div class="progress-container">
                <div class="progress-bar"></div>
            </div>

          
            <div class="loader-text">
                <p class="loader-message">Cargando datos de la tabla...</p>
                <p class="loader-percentage">Procesando información...</p>
            </div>

            
            <div class="loading-dots">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
            </div>
        </div>
   </div>
  );
};